import * as React from 'react';
import { createPortal } from 'react-dom';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import './HelpModal.scss';
import '../HelpIconButton/HelpIconButton.scss';

type Props = {
  isOpen: boolean;
  title: string;
  subtitle?: string;
  badgeText?: string;
  onClose: () => void;
  children?: React.ReactNode;
};

export const HelpModal: React.FC<Props> = ({ isOpen, title, subtitle, badgeText, onClose, children }) => {
  if (!isOpen || typeof document === 'undefined') return null;

  return createPortal(
    <SimpleModal
      isOpen={isOpen}
      title={title}
      showFooter={false}
      onCloseClick={onClose}
      customClass="modal-lg sitHelpModal"
      zIndex={1200}
    >
      <div className="sitHelpModal__content">
        {(subtitle || badgeText) && (
          <div className="sitHelpModal__intro">
            <div className="sitHelpModal__introIcon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="8.5" />
                <path d="M9.8 9.35a2.35 2.35 0 0 1 4.48 1c0 1.75-2.28 2.05-2.28 3.65" />
                <path d="M12 17.25h.01" />
              </svg>
            </div>
            <div className="sitHelpModal__introCopy">
              {badgeText ? <span className="sitHelpModal__badge">{badgeText}</span> : null}
              {subtitle ? <p>{subtitle}</p> : null}
            </div>
          </div>
        )}
        <div className="sitHelpModal__body">{children}</div>
      </div>
    </SimpleModal>,
    document.body
  );
};

HelpModal.displayName = 'HelpModal';
